module.exports = __webpack_public_path__ + "img/home_p4_icon4.9a7574ca.png";